export default __webpack_public_path__ + "static/media/badge_mig.1dddf7fc.svg";